module.exports = __webpack_public_path__ + "img/angrybanker_portrait_background.ed7ece52.png";